import { ContentType } from 'lib/services/models/types';
import { createContext, useContext, ReactNode } from 'react';

export interface FacetConfig {
  facetGroup: FacetGroup[];
}

type FacetSortOrder = 'alphabetical' | 'count';
export interface FacetGroup {
  groupName: string;
  groupLabel: string;
  facets: FacetValue[];
  expandedByDefault?: boolean;
  sortOrder?: FacetSortOrder;
  isContentType?: boolean;
  contentType?: ContentType;
  showMoreThreshold?: number;
}

export interface FacetValue {
  valueLabel: string;
  facetId: string;
  isPinned?: boolean;
}

export interface FacetConfigContextProps {
  facetConfig: FacetConfig;
  getFacetId: (groupName: string, facetValue: string) => string | undefined;
}

const FacetConfigContext = createContext<FacetConfigContextProps>({
  facetConfig: { facetGroup: [] },
  getFacetId: () => undefined,
});

export const useFacetConfig = () => {
  return useContext(FacetConfigContext);
};

export const FacetConfigProvider = ({
  children,
  facetConfig,
}: {
  children: ReactNode;
  facetConfig?: FacetConfig;
}) => {
  const effectiveConfig: FacetConfig = facetConfig ?? { facetGroup: [] };

  const getFacetId = (groupName: string, facetValue: string) => {
    return effectiveConfig.facetGroup
      .find((x) => x.groupName === groupName)
      ?.facets.find((y) => y.valueLabel === facetValue)?.facetId;
  };
  return (
    <FacetConfigContext.Provider value={{ facetConfig: effectiveConfig, getFacetId }}>
      {children}
    </FacetConfigContext.Provider>
  );
};
